import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    Date: any;
};

export type Articoli = {
    __typename?: 'Articoli';
    lista: Array<Maybe<ArticoloConOrdine>>;
    conta: Scalars['Int'];
};

export type ArticoloConOrdine = {
    __typename?: 'ArticoloConOrdine';
    id?: Maybe<Scalars['Int']>;
    ordine?: Maybe<OrdineDaArticolo>;
    COD_ART: Scalars['String'];
    DES_ART: Scalars['String'];
    COD_LOT?: Maybe<Scalars['String']>;
    COD_DEP?: Maybe<Scalars['String']>;
    DATA_SCAD?: Maybe<Scalars['Date']>;
    quantita: Scalars['Int'];
};

export type ArticoloInOrdine = {
    __typename?: 'ArticoloInOrdine';
    id?: Maybe<Scalars['Int']>;
    COD_ART: Scalars['String'];
    DES_ART: Scalars['String'];
    COD_LOT?: Maybe<Scalars['String']>;
    COD_DEP?: Maybe<Scalars['String']>;
    DATA_SCAD?: Maybe<Scalars['Date']>;
    quantita: Scalars['Int'];
    ordine?: Maybe<Scalars['Int']>;
};

export type ArticoloInput = {
    COD_ART: Scalars['String'];
    DES_ART: Scalars['String'];
    COD_LOT?: Maybe<Scalars['String']>;
    COD_DEP?: Maybe<Scalars['String']>;
    DATA_SCAD?: Maybe<Scalars['Date']>;
    quantita: Scalars['Int'];
};

export type Auth = {
    __typename?: 'Auth';
    id?: Maybe<Scalars['Int']>;
    token?: Maybe<Scalars['String']>;
    username?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    ruolo?: Maybe<Ruolo>;
    cliente?: Maybe<Cliente>;
    avatar?: Maybe<Scalars['String']>;
    ultimoAccesso?: Maybe<Scalars['Date']>;
    statoUtente?: Maybe<Scalars['String']>;
    tipologiaGiacenze?: Maybe<Scalars['Int']>;
};

export type Cliente = {
    __typename?: 'Cliente';
    id?: Maybe<Scalars['Int']>;
    cod_cf?: Maybe<Scalars['String']>;
    cod_cf_in?: Maybe<Scalars['String']>;
    precod?: Maybe<Scalars['String']>;
    ragioneSociale?: Maybe<Scalars['String']>;
    indirizzo?: Maybe<Scalars['String']>;
    comune?: Maybe<Scalars['String']>;
    prov?: Maybe<Scalars['String']>;
    cap?: Maybe<Scalars['String']>;
    telefono?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    piva?: Maybe<Scalars['String']>;
    statoCliente?: Maybe<Scalars['String']>;
    orarioAperturaMattina?: Maybe<Scalars['String']>;
    orarioChiusuraMattina?: Maybe<Scalars['String']>;
    orarioAperturaPomeriggio?: Maybe<Scalars['String']>;
    orarioChiusuraPomeriggio?: Maybe<Scalars['String']>;
};

export type Clienti = {
    __typename?: 'Clienti';
    clienti?: Maybe<Array<Maybe<Cliente>>>;
    conta?: Maybe<Scalars['Int']>;
};

export type Destinazione = {
    __typename?: 'Destinazione';
    DES_DEST_MERCE?: Maybe<Scalars['String']>;
    INDI_DEST_MERCE?: Maybe<Scalars['String']>;
    CAP_DEST_MERCE?: Maybe<Scalars['String']>;
    COMUNE_DEST_MERCE?: Maybe<Scalars['String']>;
    PROVINCIA_DEST_MERCE?: Maybe<Scalars['String']>;
    STATO_DEST_MERCE?: Maybe<Scalars['String']>;
    TEL_DEST_MERCE?: Maybe<Scalars['String']>;
};

export type DettagliMovimento = {
    __typename?: 'DettagliMovimento';
    COD_ART?: Maybe<Scalars['String']>;
    DES_RIGA?: Maybe<Scalars['String']>;
    QUANT_RIGA?: Maybe<Scalars['Float']>;
    PESO_NETTO?: Maybe<Scalars['Float']>;
};

export type Giacenza = {
    __typename?: 'Giacenza';
    COD_ART?: Maybe<Scalars['String']>;
    DES_ART?: Maybe<Scalars['String']>;
    COD_DEP?: Maybe<Scalars['String']>;
    COD_LOT?: Maybe<Scalars['String']>;
    DATA_SCAD?: Maybe<Scalars['String']>;
    COD_CAT?: Maybe<Scalars['String']>;
    GIACENZA_ATTUALE?: Maybe<Scalars['Float']>;
    IMPEGNO?: Maybe<Scalars['Int']>;
    RESIDUO?: Maybe<Scalars['Int']>;
};

export type Giacenze = {
    __typename?: 'Giacenze';
    articoli?: Maybe<Array<Maybe<Giacenza>>>;
    conta?: Maybe<Scalars['Int']>;
};

export type MovimentiInIngresso = {
    __typename?: 'MovimentiInIngresso';
    movimenti?: Maybe<Array<Maybe<MovimentoInIngresso>>>;
    count?: Maybe<Scalars['Int']>;
};

export type MovimentiInUscita = {
    __typename?: 'MovimentiInUscita';
    movimenti?: Maybe<Array<Maybe<MovimentoInUscita>>>;
    count?: Maybe<Scalars['Int']>;
};

export type MovimentoInIngresso = {
    __typename?: 'MovimentoInIngresso';
    DOC_ID?: Maybe<Scalars['String']>;
    ANNO_DOC?: Maybe<Scalars['String']>;
    NUM_DOC?: Maybe<Scalars['Int']>;
    DATA_DOC?: Maybe<Scalars['Date']>;
    NUM_DDT_FOR?: Maybe<Scalars['String']>;
    DATA_DDT_FOR?: Maybe<Scalars['String']>;
    COD_CF?: Maybe<Scalars['String']>;
    cliente?: Maybe<Cliente>;
};

export type MovimentoInUscita = {
    __typename?: 'MovimentoInUscita';
    DOC_ID?: Maybe<Scalars['String']>;
    ANNO_DOC?: Maybe<Scalars['String']>;
    NUM_DOC?: Maybe<Scalars['Int']>;
    DATA_DOC?: Maybe<Scalars['Date']>;
    DATA_DDT_FOR?: Maybe<Scalars['String']>;
    COD_CF?: Maybe<Scalars['String']>;
    cliente?: Maybe<Cliente>;
};

export type Mutation = {
    __typename?: 'Mutation';
    registraUtente?: Maybe<Auth>;
    modificaUtente?: Maybe<Auth>;
    login?: Maybe<Auth>;
    aggiungiCliente?: Maybe<Cliente>;
    modificaStatoUtente?: Maybe<Array<Maybe<Auth>>>;
    modificaStatoCliente?: Maybe<Clienti>;
    modificaStatoOrdine?: Maybe<Ordini>;
    registraOrdine?: Maybe<Articoli>;
    aggiungiArticoloInOrdine?: Maybe<ArticoloConOrdine>;
    modificaPasswordUtente?: Maybe<Auth>;
    assegnaDocumento?: Maybe<OrdineConArticoli>;
};

export type MutationRegistraUtenteArgs = {
    username: Scalars['String'];
    email: Scalars['String'];
    password: Scalars['String'];
    ruolo?: Maybe<Scalars['String']>;
    piva?: Maybe<Scalars['String']>;
    titoloMessaggio?: Maybe<Scalars['String']>;
    corpoMessaggio?: Maybe<Scalars['String']>;
};

export type MutationModificaUtenteArgs = {
    cod_cf: Scalars['String'];
    email: Scalars['String'];
    ruolo: Scalars['Int'];
    piva?: Maybe<Scalars['String']>;
    tipologiaGiacenze: Scalars['Int'];
};

export type MutationLoginArgs = {
    _email: Scalars['String'];
    password: Scalars['String'];
};

export type MutationAggiungiClienteArgs = {
    precod: Scalars['String'];
    cod_cf: Scalars['String'];
    cod_cf_in: Scalars['String'];
    ragioneSociale: Scalars['String'];
    piva: Scalars['String'];
    indirizzo: Scalars['String'];
    comune: Scalars['String'];
    prov: Scalars['String'];
    cap: Scalars['String'];
    email?: Maybe<Scalars['String']>;
    telefono?: Maybe<Scalars['String']>;
    orarioAperturaMattina?: Maybe<Scalars['String']>;
    orarioChiusuraMattina?: Maybe<Scalars['String']>;
    orarioAperturaPomeriggio?: Maybe<Scalars['String']>;
    orarioChiusuraPomeriggio?: Maybe<Scalars['String']>;
};

export type MutationModificaStatoUtenteArgs = {
    email: Scalars['String'];
    statoUtente: Scalars['String'];
};

export type MutationModificaStatoClienteArgs = {
    piva: Scalars['String'];
    statoCliente: Scalars['String'];
};

export type MutationModificaStatoOrdineArgs = {
    ordine: Scalars['Int'];
    statoOrdine: Scalars['Int'];
};

export type MutationRegistraOrdineArgs = {
    destinatario: Scalars['String'];
    indirizzo: Scalars['String'];
    comune: Scalars['String'];
    prov: Scalars['String'];
    cap: Scalars['String'];
    dataConsegna?: Maybe<Scalars['Date']>;
    dataRitiro?: Maybe<Scalars['Date']>;
    orarioCarico?: Maybe<Scalars['String']>;
    orarioAperturaMattina?: Maybe<Scalars['String']>;
    orarioChiusuraMattina?: Maybe<Scalars['String']>;
    orarioAperturaPomeriggio?: Maybe<Scalars['String']>;
    orarioChiusuraPomeriggio?: Maybe<Scalars['String']>;
    note?: Maybe<Scalars['String']>;
    articoli: Array<Maybe<ArticoloInput>>;
    sommaPagamento?: Maybe<Scalars['Float']>;
    contanti?: Maybe<Scalars['Boolean']>;
    tel?: Maybe<Scalars['String']>;
};

export type MutationAggiungiArticoloInOrdineArgs = {
    ordine: Scalars['Int'];
    codiceArticolo: Scalars['String'];
    descrizioneArticolo: Scalars['String'];
    codiceLotto?: Maybe<Scalars['String']>;
    codiceDeposito?: Maybe<Scalars['String']>;
    dataScadenza?: Maybe<Scalars['Date']>;
    quantita: Scalars['Int'];
};

export type MutationModificaPasswordUtenteArgs = {
    email: Scalars['String'];
    password: Scalars['String'];
};

export type MutationAssegnaDocumentoArgs = {
    ordine: Scalars['Int'];
    documento?: Maybe<Scalars['String']>;
};

export type OrdineConArticoli = {
    __typename?: 'OrdineConArticoli';
    id?: Maybe<Scalars['Int']>;
    destinatario: Scalars['String'];
    indirizzo: Scalars['String'];
    comune: Scalars['String'];
    prov: Scalars['String'];
    cap: Scalars['String'];
    cliente?: Maybe<Cliente>;
    statoOrdine?: Maybe<Scalars['Int']>;
    dataOrdine?: Maybe<Scalars['Date']>;
    dataConsegna?: Maybe<Scalars['Date']>;
    dataRitiro?: Maybe<Scalars['Date']>;
    orarioCarico?: Maybe<Scalars['String']>;
    orarioAperturaMattina?: Maybe<Scalars['String']>;
    orarioChiusuraMattina?: Maybe<Scalars['String']>;
    orarioAperturaPomeriggio?: Maybe<Scalars['String']>;
    orarioChiusuraPomeriggio?: Maybe<Scalars['String']>;
    note?: Maybe<Scalars['String']>;
    articoli: Array<Maybe<ArticoloInOrdine>>;
    sommaPagamento?: Maybe<Scalars['Float']>;
    contanti: Scalars['Boolean'];
    documento?: Maybe<Scalars['String']>;
    tel?: Maybe<Scalars['String']>;
};

export type OrdineDaArticolo = {
    __typename?: 'OrdineDaArticolo';
    id?: Maybe<Scalars['Int']>;
    destinatario: Scalars['String'];
    cliente?: Maybe<Cliente>;
    statoOrdine?: Maybe<Scalars['Int']>;
    dataOrdine?: Maybe<Scalars['Date']>;
    dataConsegna?: Maybe<Scalars['Date']>;
    dataRitiro?: Maybe<Scalars['Date']>;
    orarioAperturaMattina?: Maybe<Scalars['String']>;
    orarioChiusuraMattina?: Maybe<Scalars['String']>;
    orarioAperturaPomeriggio?: Maybe<Scalars['String']>;
    orarioChiusuraPomeriggio?: Maybe<Scalars['String']>;
    note?: Maybe<Scalars['String']>;
    documento?: Maybe<Scalars['String']>;
    tel?: Maybe<Scalars['String']>;
};

export type Ordini = {
    __typename?: 'Ordini';
    lista: Array<Maybe<OrdineConArticoli>>;
    conta: Scalars['Int'];
};

export type PasswordCasuale = {
    __typename?: 'PasswordCasuale';
    password?: Maybe<Scalars['String']>;
};

export type Query = {
    __typename?: 'Query';
    me?: Maybe<Auth>;
    usersByKeyword?: Maybe<Array<Maybe<Auth>>>;
    users?: Maybe<Array<Maybe<Auth>>>;
    giacenze?: Maybe<Giacenze>;
    giacenzeByKeyword?: Maybe<Giacenze>;
    giacenzeByArticolo?: Maybe<Giacenze>;
    giacenzeByArticoloByKeyword?: Maybe<Giacenze>;
    cliente?: Maybe<Cliente>;
    clienti?: Maybe<Clienti>;
    clientiByKeyword?: Maybe<Clienti>;
    ordini?: Maybe<Ordini>;
    ordiniByKeyword?: Maybe<Ordini>;
    fetchArticoliByOrdine?: Maybe<Articoli>;
    ruoli?: Maybe<Array<Maybe<Ruolo>>>;
    generaPasswordCasuale?: Maybe<PasswordCasuale>;
    movimentiInIngresso?: Maybe<MovimentiInIngresso>;
    movimentiInUscita?: Maybe<MovimentiInUscita>;
    dettagliMovimentoInIngresso?: Maybe<Array<Maybe<DettagliMovimento>>>;
    dettagliMovimentoInUscita?: Maybe<Array<Maybe<DettagliMovimento>>>;
    fetchBolla?: Maybe<Scalars['String']>;
    destinazione?: Maybe<Destinazione>;
    temp__?: Maybe<Scalars['Boolean']>;
};

export type QueryUsersByKeywordArgs = {
    criterioDiRicerca: Scalars['String'];
};

export type QueryGiacenzeArgs = {
    PreCod: Scalars['String'];
    Totali: Scalars['Int'];
    Obsoleti: Scalars['Int'];
    Categoria: Scalars['String'];
    offset: Scalars['Int'];
    limit: Scalars['Int'];
};

export type QueryGiacenzeByKeywordArgs = {
    PreCod: Scalars['String'];
    Totali: Scalars['Int'];
    Obsoleti: Scalars['Int'];
    Categoria: Scalars['String'];
    offset: Scalars['Int'];
    limit: Scalars['Int'];
    criterioDiRicerca: Scalars['String'];
};

export type QueryGiacenzeByArticoloArgs = {
    PreCod: Scalars['String'];
    Totali: Scalars['Int'];
    Obsoleti: Scalars['Int'];
    Categoria: Scalars['String'];
    offset: Scalars['Int'];
    limit: Scalars['Int'];
};

export type QueryGiacenzeByArticoloByKeywordArgs = {
    PreCod: Scalars['String'];
    Totali: Scalars['Int'];
    Obsoleti: Scalars['Int'];
    Categoria: Scalars['String'];
    offset: Scalars['Int'];
    limit: Scalars['Int'];
    criterioDiRicerca: Scalars['String'];
};

export type QueryClienteArgs = {
    criterioDiRicerca: Scalars['String'];
};

export type QueryClientiArgs = {
    orderBy?: Maybe<Scalars['String']>;
    filterBy?: Maybe<Array<Maybe<Scalars['String']>>>;
    skip?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
};

export type QueryClientiByKeywordArgs = {
    criterioDiRicerca: Scalars['String'];
    orderBy?: Maybe<Scalars['String']>;
    filterBy?: Maybe<Array<Maybe<Scalars['String']>>>;
    skip?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
};

export type QueryOrdiniArgs = {
    statoOrdine?: Maybe<Array<Maybe<Scalars['Int']>>>;
    offset: Scalars['Int'];
    limit: Scalars['Int'];
};

export type QueryOrdiniByKeywordArgs = {
    statoOrdine?: Maybe<Array<Maybe<Scalars['Int']>>>;
    criterioDiRicerca: Scalars['String'];
    offset: Scalars['Int'];
    limit: Scalars['Int'];
};

export type QueryFetchArticoliByOrdineArgs = {
    ordine: Scalars['Int'];
};

export type QueryMovimentiInIngressoArgs = {
    offset: Scalars['Int'];
    limit: Scalars['Int'];
    COD_CF_IN?: Maybe<Scalars['String']>;
    criterioDiRicerca?: Maybe<Scalars['String']>;
};

export type QueryMovimentiInUscitaArgs = {
    offset: Scalars['Int'];
    limit: Scalars['Int'];
    COD_CF?: Maybe<Scalars['String']>;
    criterioDiRicerca?: Maybe<Scalars['String']>;
};

export type QueryDettagliMovimentoInIngressoArgs = {
    DOC_ID: Scalars['String'];
};

export type QueryDettagliMovimentoInUscitaArgs = {
    DOC_ID: Scalars['String'];
};

export type QueryFetchBollaArgs = {
    DOC_ID: Scalars['String'];
};

export type QueryDestinazioneArgs = {
    DOC_ID: Scalars['String'];
};

export type Ruolo = {
    __typename?: 'Ruolo';
    id?: Maybe<Scalars['Int']>;
    nome?: Maybe<Scalars['String']>;
};
export type AggiungiClienteMutationVariables = {
    precod: Scalars['String'];
    cod_cf: Scalars['String'];
    cod_cf_in: Scalars['String'];
    ragioneSociale: Scalars['String'];
    piva: Scalars['String'];
    indirizzo: Scalars['String'];
    comune: Scalars['String'];
    prov: Scalars['String'];
    cap: Scalars['String'];
    email?: Maybe<Scalars['String']>;
    telefono?: Maybe<Scalars['String']>;
    orarioAperturaMattina?: Maybe<Scalars['String']>;
    orarioChiusuraMattina?: Maybe<Scalars['String']>;
    orarioAperturaPomeriggio?: Maybe<Scalars['String']>;
    orarioChiusuraPomeriggio?: Maybe<Scalars['String']>;
};

export type AggiungiClienteMutation = { __typename?: 'Mutation' } & {
    aggiungiCliente: Maybe<
        { __typename?: 'Cliente' } & Pick<
            Cliente,
            | 'cod_cf'
            | 'cod_cf_in'
            | 'precod'
            | 'ragioneSociale'
            | 'indirizzo'
            | 'comune'
            | 'prov'
            | 'cap'
            | 'telefono'
            | 'email'
            | 'piva'
            | 'statoCliente'
        >
    >;
};

export type AssegnaDocumentoMutationVariables = {
    ordine: Scalars['Int'];
    documento?: Maybe<Scalars['String']>;
};

export type AssegnaDocumentoMutation = { __typename?: 'Mutation' } & {
    assegnaDocumento: Maybe<
        { __typename?: 'OrdineConArticoli' } & Pick<
            OrdineConArticoli,
            'id' | 'documento'
        >
    >;
};

export type LoginMutationVariables = {
    email: Scalars['String'];
    password: Scalars['String'];
};

export type LoginMutation = { __typename?: 'Mutation' } & {
    login: Maybe<
        { __typename?: 'Auth' } & Pick<
            Auth,
            'username' | 'email' | 'token' | 'avatar'
        > & {
                ruolo: Maybe<
                    { __typename?: 'Ruolo' } & Pick<Ruolo, 'id' | 'nome'>
                >;
                cliente: Maybe<
                    { __typename?: 'Cliente' } & Pick<
                        Cliente,
                        'id' | 'ragioneSociale' | 'piva'
                    >
                >;
            }
    >;
};

export type ModificaPasswordUtenteMutationVariables = {
    email: Scalars['String'];
    password: Scalars['String'];
};

export type ModificaPasswordUtenteMutation = { __typename?: 'Mutation' } & {
    modificaPasswordUtente: Maybe<
        { __typename?: 'Auth' } & Pick<
            Auth,
            'username' | 'email' | 'ultimoAccesso' | 'statoUtente'
        > & {
                ruolo: Maybe<
                    { __typename?: 'Ruolo' } & Pick<Ruolo, 'id' | 'nome'>
                >;
                cliente: Maybe<
                    { __typename?: 'Cliente' } & Pick<
                        Cliente,
                        'id' | 'ragioneSociale' | 'piva'
                    >
                >;
            }
    >;
};

export type ModificaStatoClienteMutationVariables = {
    piva: Scalars['String'];
    statoCliente: Scalars['String'];
};

export type ModificaStatoClienteMutation = { __typename?: 'Mutation' } & {
    modificaStatoCliente: Maybe<
        { __typename?: 'Clienti' } & Pick<Clienti, 'conta'> & {
                clienti: Maybe<
                    Array<
                        Maybe<
                            { __typename?: 'Cliente' } & Pick<
                                Cliente,
                                | 'cod_cf'
                                | 'cod_cf_in'
                                | 'precod'
                                | 'ragioneSociale'
                                | 'indirizzo'
                                | 'comune'
                                | 'prov'
                                | 'cap'
                                | 'telefono'
                                | 'email'
                                | 'piva'
                                | 'statoCliente'
                            >
                        >
                    >
                >;
            }
    >;
};

export type ModificaStatoOrdineMutationVariables = {
    ordine: Scalars['Int'];
    statoOrdine: Scalars['Int'];
};

export type ModificaStatoOrdineMutation = { __typename?: 'Mutation' } & {
    modificaStatoOrdine: Maybe<
        { __typename?: 'Ordini' } & Pick<Ordini, 'conta'> & {
                lista: Array<
                    Maybe<
                        { __typename?: 'OrdineConArticoli' } & Pick<
                            OrdineConArticoli,
                            | 'id'
                            | 'statoOrdine'
                            | 'dataOrdine'
                            | 'dataConsegna'
                            | 'orarioAperturaMattina'
                            | 'orarioChiusuraMattina'
                            | 'orarioAperturaPomeriggio'
                            | 'orarioChiusuraPomeriggio'
                            | 'note'
                        > & {
                                cliente: Maybe<
                                    { __typename?: 'Cliente' } & Pick<
                                        Cliente,
                                        | 'id'
                                        | 'cod_cf'
                                        | 'cod_cf_in'
                                        | 'precod'
                                        | 'ragioneSociale'
                                        | 'indirizzo'
                                        | 'comune'
                                        | 'prov'
                                        | 'cap'
                                        | 'telefono'
                                        | 'email'
                                        | 'piva'
                                        | 'statoCliente'
                                    >
                                >;
                            }
                    >
                >;
            }
    >;
};

export type ModificaStatoUtenteMutationVariables = {
    email: Scalars['String'];
    statoUtente: Scalars['String'];
};

export type ModificaStatoUtenteMutation = { __typename?: 'Mutation' } & {
    modificaStatoUtente: Maybe<
        Array<
            Maybe<
                { __typename?: 'Auth' } & Pick<
                    Auth,
                    'username' | 'email' | 'ultimoAccesso' | 'statoUtente'
                > & {
                        ruolo: Maybe<
                            { __typename?: 'Ruolo' } & Pick<
                                Ruolo,
                                'id' | 'nome'
                            >
                        >;
                        cliente: Maybe<
                            { __typename?: 'Cliente' } & Pick<
                                Cliente,
                                'id' | 'ragioneSociale' | 'piva'
                            >
                        >;
                    }
            >
        >
    >;
};

export type ModificaUtenteMutationVariables = {
    email: Scalars['String'];
    cod_cf: Scalars['String'];
    ruolo: Scalars['Int'];
    piva?: Maybe<Scalars['String']>;
    tipologiaGiacenze: Scalars['Int'];
};

export type ModificaUtenteMutation = { __typename?: 'Mutation' } & {
    modificaUtente: Maybe<
        { __typename?: 'Auth' } & Pick<
            Auth,
            | 'id'
            | 'username'
            | 'email'
            | 'ultimoAccesso'
            | 'statoUtente'
            | 'tipologiaGiacenze'
        > & {
                ruolo: Maybe<
                    { __typename?: 'Ruolo' } & Pick<Ruolo, 'id' | 'nome'>
                >;
                cliente: Maybe<
                    { __typename?: 'Cliente' } & Pick<
                        Cliente,
                        'id' | 'ragioneSociale' | 'piva' | 'cod_cf'
                    >
                >;
            }
    >;
};

export type RegistraOrdineMutationVariables = {
    destinatario: Scalars['String'];
    indirizzo: Scalars['String'];
    comune: Scalars['String'];
    prov: Scalars['String'];
    cap: Scalars['String'];
    dataConsegna?: Maybe<Scalars['Date']>;
    dataRitiro?: Maybe<Scalars['Date']>;
    orarioCarico?: Maybe<Scalars['String']>;
    orarioAperturaMattina?: Maybe<Scalars['String']>;
    orarioChiusuraMattina?: Maybe<Scalars['String']>;
    orarioAperturaPomeriggio?: Maybe<Scalars['String']>;
    orarioChiusuraPomeriggio?: Maybe<Scalars['String']>;
    note?: Maybe<Scalars['String']>;
    articoli: Array<Maybe<ArticoloInput>>;
    sommaPagamento?: Maybe<Scalars['Float']>;
    contanti?: Maybe<Scalars['Boolean']>;
    tel?: Maybe<Scalars['String']>;
};

export type RegistraOrdineMutation = { __typename?: 'Mutation' } & {
    registraOrdine: Maybe<
        { __typename?: 'Articoli' } & Pick<Articoli, 'conta'> & {
                lista: Array<
                    Maybe<
                        { __typename?: 'ArticoloConOrdine' } & Pick<
                            ArticoloConOrdine,
                            | 'id'
                            | 'COD_ART'
                            | 'DES_ART'
                            | 'COD_LOT'
                            | 'COD_DEP'
                            | 'DATA_SCAD'
                            | 'quantita'
                        > & {
                                ordine: Maybe<
                                    { __typename?: 'OrdineDaArticolo' } & Pick<
                                        OrdineDaArticolo,
                                        | 'id'
                                        | 'destinatario'
                                        | 'statoOrdine'
                                        | 'dataOrdine'
                                        | 'dataConsegna'
                                        | 'dataRitiro'
                                        | 'orarioAperturaMattina'
                                        | 'orarioChiusuraMattina'
                                        | 'orarioAperturaPomeriggio'
                                        | 'orarioChiusuraPomeriggio'
                                        | 'note'
                                        | 'documento'
                                        | 'tel'
                                    > & {
                                            cliente: Maybe<
                                                {
                                                    __typename?: 'Cliente';
                                                } & Pick<
                                                    Cliente,
                                                    | 'id'
                                                    | 'cod_cf'
                                                    | 'cod_cf_in'
                                                    | 'precod'
                                                    | 'ragioneSociale'
                                                    | 'indirizzo'
                                                    | 'comune'
                                                    | 'prov'
                                                    | 'cap'
                                                    | 'telefono'
                                                    | 'email'
                                                    | 'piva'
                                                    | 'statoCliente'
                                                    | 'orarioAperturaMattina'
                                                    | 'orarioChiusuraMattina'
                                                    | 'orarioAperturaPomeriggio'
                                                    | 'orarioChiusuraPomeriggio'
                                                >
                                            >;
                                        }
                                >;
                            }
                    >
                >;
            }
    >;
};

export type RegistraUtenteMutationVariables = {
    username: Scalars['String'];
    email: Scalars['String'];
    password: Scalars['String'];
    ruolo?: Maybe<Scalars['String']>;
    piva?: Maybe<Scalars['String']>;
};

export type RegistraUtenteMutation = { __typename?: 'Mutation' } & {
    registraUtente: Maybe<
        { __typename?: 'Auth' } & Pick<Auth, 'id' | 'username' | 'email'> & {
                ruolo: Maybe<
                    { __typename?: 'Ruolo' } & Pick<Ruolo, 'id' | 'nome'>
                >;
                cliente: Maybe<
                    { __typename?: 'Cliente' } & Pick<
                        Cliente,
                        'id' | 'ragioneSociale' | 'piva'
                    >
                >;
            }
    >;
};

export type ClientiByKeywordQueryVariables = {
    criterioDiRicerca: Scalars['String'];
    orderBy?: Maybe<Scalars['String']>;
    filterBy?: Maybe<Array<Maybe<Scalars['String']>>>;
    skip?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
};

export type ClientiByKeywordQuery = { __typename?: 'Query' } & {
    clientiByKeyword: Maybe<
        { __typename?: 'Clienti' } & Pick<Clienti, 'conta'> & {
                clienti: Maybe<
                    Array<
                        Maybe<
                            { __typename?: 'Cliente' } & Pick<
                                Cliente,
                                | 'id'
                                | 'cod_cf'
                                | 'cod_cf_in'
                                | 'precod'
                                | 'ragioneSociale'
                                | 'indirizzo'
                                | 'comune'
                                | 'prov'
                                | 'cap'
                                | 'telefono'
                                | 'email'
                                | 'piva'
                                | 'statoCliente'
                            >
                        >
                    >
                >;
            }
    >;
};

export type ClientiQueryVariables = {
    orderBy?: Maybe<Scalars['String']>;
    filterBy?: Maybe<Array<Maybe<Scalars['String']>>>;
    skip?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
};

export type ClientiQuery = { __typename?: 'Query' } & {
    clienti: Maybe<
        { __typename?: 'Clienti' } & Pick<Clienti, 'conta'> & {
                clienti: Maybe<
                    Array<
                        Maybe<
                            { __typename?: 'Cliente' } & Pick<
                                Cliente,
                                | 'cod_cf'
                                | 'cod_cf_in'
                                | 'precod'
                                | 'ragioneSociale'
                                | 'indirizzo'
                                | 'comune'
                                | 'prov'
                                | 'cap'
                                | 'telefono'
                                | 'email'
                                | 'piva'
                                | 'statoCliente'
                            >
                        >
                    >
                >;
            }
    >;
};

export type DestinazioneQueryVariables = {
    DOC_ID: Scalars['String'];
};

export type DestinazioneQuery = { __typename?: 'Query' } & {
    destinazione: Maybe<
        { __typename?: 'Destinazione' } & Pick<
            Destinazione,
            | 'DES_DEST_MERCE'
            | 'INDI_DEST_MERCE'
            | 'CAP_DEST_MERCE'
            | 'COMUNE_DEST_MERCE'
            | 'PROVINCIA_DEST_MERCE'
            | 'STATO_DEST_MERCE'
            | 'TEL_DEST_MERCE'
        >
    >;
};

export type DettagliMovimentoInIngressoQueryVariables = {
    DOC_ID: Scalars['String'];
};

export type DettagliMovimentoInIngressoQuery = { __typename?: 'Query' } & {
    dettagliMovimentoInIngresso: Maybe<
        Array<
            Maybe<
                { __typename?: 'DettagliMovimento' } & Pick<
                    DettagliMovimento,
                    'COD_ART' | 'DES_RIGA' | 'QUANT_RIGA' | 'PESO_NETTO'
                >
            >
        >
    >;
};

export type DettagliMovimentoInUscitaQueryVariables = {
    DOC_ID: Scalars['String'];
};

export type DettagliMovimentoInUscitaQuery = { __typename?: 'Query' } & {
    dettagliMovimentoInUscita: Maybe<
        Array<
            Maybe<
                { __typename?: 'DettagliMovimento' } & Pick<
                    DettagliMovimento,
                    'COD_ART' | 'DES_RIGA' | 'QUANT_RIGA' | 'PESO_NETTO'
                >
            >
        >
    >;
};

export type FetchArticoliByOrdineQueryVariables = {
    ordine: Scalars['Int'];
};

export type FetchArticoliByOrdineQuery = { __typename?: 'Query' } & {
    fetchArticoliByOrdine: Maybe<
        { __typename?: 'Articoli' } & Pick<Articoli, 'conta'> & {
                lista: Array<
                    Maybe<
                        { __typename?: 'ArticoloConOrdine' } & Pick<
                            ArticoloConOrdine,
                            | 'id'
                            | 'COD_ART'
                            | 'DES_ART'
                            | 'quantita'
                            | 'DATA_SCAD'
                            | 'COD_LOT'
                            | 'COD_DEP'
                        > & {
                                ordine: Maybe<
                                    { __typename?: 'OrdineDaArticolo' } & Pick<
                                        OrdineDaArticolo,
                                        'id' | 'documento'
                                    > & {
                                            cliente: Maybe<
                                                {
                                                    __typename?: 'Cliente';
                                                } & Pick<
                                                    Cliente,
                                                    | 'id'
                                                    | 'cod_cf'
                                                    | 'cod_cf_in'
                                                    | 'precod'
                                                    | 'ragioneSociale'
                                                    | 'indirizzo'
                                                    | 'comune'
                                                    | 'prov'
                                                    | 'cap'
                                                    | 'telefono'
                                                    | 'email'
                                                    | 'piva'
                                                    | 'statoCliente'
                                                >
                                            >;
                                        }
                                >;
                            }
                    >
                >;
            }
    >;
};

export type FetchBollaQueryVariables = {
    DOC_ID: Scalars['String'];
};

export type FetchBollaQuery = { __typename?: 'Query' } & Pick<
    Query,
    'fetchBolla'
>;

export type GeneraPasswordCasualeQueryVariables = {};

export type GeneraPasswordCasualeQuery = { __typename?: 'Query' } & {
    generaPasswordCasuale: Maybe<
        { __typename?: 'PasswordCasuale' } & Pick<PasswordCasuale, 'password'>
    >;
};

export type GiacenzeByArticoloByKeywordQueryVariables = {
    PreCod: Scalars['String'];
    Totali: Scalars['Int'];
    Obsoleti: Scalars['Int'];
    Categoria: Scalars['String'];
    offset: Scalars['Int'];
    limit: Scalars['Int'];
    criterioDiRicerca: Scalars['String'];
};

export type GiacenzeByArticoloByKeywordQuery = { __typename?: 'Query' } & {
    giacenzeByArticoloByKeyword: Maybe<
        { __typename?: 'Giacenze' } & Pick<Giacenze, 'conta'> & {
                articoli: Maybe<
                    Array<
                        Maybe<
                            { __typename?: 'Giacenza' } & Pick<
                                Giacenza,
                                | 'COD_ART'
                                | 'DES_ART'
                                | 'GIACENZA_ATTUALE'
                                | 'RESIDUO'
                                | 'IMPEGNO'
                            >
                        >
                    >
                >;
            }
    >;
};

export type GiacenzeByArticoloQueryVariables = {
    PreCod: Scalars['String'];
    Totali: Scalars['Int'];
    Obsoleti: Scalars['Int'];
    Categoria: Scalars['String'];
    offset: Scalars['Int'];
    limit: Scalars['Int'];
};

export type GiacenzeByArticoloQuery = { __typename?: 'Query' } & {
    giacenzeByArticolo: Maybe<
        { __typename?: 'Giacenze' } & Pick<Giacenze, 'conta'> & {
                articoli: Maybe<
                    Array<
                        Maybe<
                            { __typename?: 'Giacenza' } & Pick<
                                Giacenza,
                                | 'COD_ART'
                                | 'DES_ART'
                                | 'GIACENZA_ATTUALE'
                                | 'RESIDUO'
                                | 'IMPEGNO'
                            >
                        >
                    >
                >;
            }
    >;
};

export type GiacenzeByKeywordQueryVariables = {
    PreCod: Scalars['String'];
    Totali: Scalars['Int'];
    Obsoleti: Scalars['Int'];
    Categoria: Scalars['String'];
    offset: Scalars['Int'];
    limit: Scalars['Int'];
    criterioDiRicerca: Scalars['String'];
};

export type GiacenzeByKeywordQuery = { __typename?: 'Query' } & {
    giacenzeByKeyword: Maybe<
        { __typename?: 'Giacenze' } & Pick<Giacenze, 'conta'> & {
                articoli: Maybe<
                    Array<
                        Maybe<
                            { __typename?: 'Giacenza' } & Pick<
                                Giacenza,
                                | 'COD_ART'
                                | 'DES_ART'
                                | 'GIACENZA_ATTUALE'
                                | 'RESIDUO'
                                | 'IMPEGNO'
                                | 'COD_DEP'
                                | 'COD_LOT'
                                | 'DATA_SCAD'
                                | 'COD_CAT'
                            >
                        >
                    >
                >;
            }
    >;
};

export type GiacenzeQueryVariables = {
    PreCod: Scalars['String'];
    Totali: Scalars['Int'];
    Obsoleti: Scalars['Int'];
    Categoria: Scalars['String'];
    offset: Scalars['Int'];
    limit: Scalars['Int'];
};

export type GiacenzeQuery = { __typename?: 'Query' } & {
    giacenze: Maybe<
        { __typename?: 'Giacenze' } & Pick<Giacenze, 'conta'> & {
                articoli: Maybe<
                    Array<
                        Maybe<
                            { __typename?: 'Giacenza' } & Pick<
                                Giacenza,
                                | 'COD_ART'
                                | 'DES_ART'
                                | 'GIACENZA_ATTUALE'
                                | 'RESIDUO'
                                | 'IMPEGNO'
                                | 'COD_DEP'
                                | 'COD_LOT'
                                | 'DATA_SCAD'
                                | 'COD_CAT'
                            >
                        >
                    >
                >;
            }
    >;
};

export type MeQueryVariables = {};

export type MeQuery = { __typename?: 'Query' } & {
    me: Maybe<
        { __typename?: 'Auth' } & Pick<
            Auth,
            'username' | 'email' | 'token' | 'avatar' | 'tipologiaGiacenze'
        > & {
                ruolo: Maybe<
                    { __typename?: 'Ruolo' } & Pick<Ruolo, 'id' | 'nome'>
                >;
                cliente: Maybe<
                    { __typename?: 'Cliente' } & Pick<
                        Cliente,
                        | 'id'
                        | 'cod_cf'
                        | 'cod_cf_in'
                        | 'precod'
                        | 'ragioneSociale'
                        | 'indirizzo'
                        | 'comune'
                        | 'prov'
                        | 'cap'
                        | 'telefono'
                        | 'email'
                        | 'piva'
                        | 'statoCliente'
                        | 'orarioAperturaMattina'
                        | 'orarioChiusuraMattina'
                        | 'orarioAperturaPomeriggio'
                        | 'orarioChiusuraPomeriggio'
                    >
                >;
            }
    >;
};

export type MovimentiInIngressoQueryVariables = {
    offset: Scalars['Int'];
    limit: Scalars['Int'];
    COD_CF_IN?: Maybe<Scalars['String']>;
    criterioDiRicerca?: Maybe<Scalars['String']>;
};

export type MovimentiInIngressoQuery = { __typename?: 'Query' } & {
    movimentiInIngresso: Maybe<
        { __typename?: 'MovimentiInIngresso' } & Pick<
            MovimentiInIngresso,
            'count'
        > & {
                movimenti: Maybe<
                    Array<
                        Maybe<
                            { __typename?: 'MovimentoInIngresso' } & Pick<
                                MovimentoInIngresso,
                                | 'DOC_ID'
                                | 'ANNO_DOC'
                                | 'NUM_DOC'
                                | 'DATA_DOC'
                                | 'NUM_DDT_FOR'
                                | 'DATA_DDT_FOR'
                                | 'COD_CF'
                            > & {
                                    cliente: Maybe<
                                        { __typename?: 'Cliente' } & Pick<
                                            Cliente,
                                            | 'id'
                                            | 'cod_cf'
                                            | 'cod_cf_in'
                                            | 'precod'
                                            | 'ragioneSociale'
                                            | 'indirizzo'
                                            | 'comune'
                                            | 'prov'
                                            | 'cap'
                                            | 'telefono'
                                            | 'email'
                                            | 'piva'
                                            | 'statoCliente'
                                        >
                                    >;
                                }
                        >
                    >
                >;
            }
    >;
};

export type MovimentiInUscitaQueryVariables = {
    offset: Scalars['Int'];
    limit: Scalars['Int'];
    COD_CF?: Maybe<Scalars['String']>;
    criterioDiRicerca?: Maybe<Scalars['String']>;
};

export type MovimentiInUscitaQuery = { __typename?: 'Query' } & {
    movimentiInUscita: Maybe<
        { __typename?: 'MovimentiInUscita' } & Pick<
            MovimentiInUscita,
            'count'
        > & {
                movimenti: Maybe<
                    Array<
                        Maybe<
                            { __typename?: 'MovimentoInUscita' } & Pick<
                                MovimentoInUscita,
                                | 'DOC_ID'
                                | 'ANNO_DOC'
                                | 'NUM_DOC'
                                | 'DATA_DOC'
                                | 'COD_CF'
                            > & {
                                    cliente: Maybe<
                                        { __typename?: 'Cliente' } & Pick<
                                            Cliente,
                                            | 'id'
                                            | 'cod_cf'
                                            | 'cod_cf_in'
                                            | 'precod'
                                            | 'ragioneSociale'
                                            | 'indirizzo'
                                            | 'comune'
                                            | 'prov'
                                            | 'cap'
                                            | 'telefono'
                                            | 'email'
                                            | 'piva'
                                            | 'statoCliente'
                                        >
                                    >;
                                }
                        >
                    >
                >;
            }
    >;
};

export type OrdiniByKeywordQueryVariables = {
    statoOrdine?: Maybe<Array<Maybe<Scalars['Int']>>>;
    criterioDiRicerca: Scalars['String'];
    offset: Scalars['Int'];
    limit: Scalars['Int'];
};

export type OrdiniByKeywordQuery = { __typename?: 'Query' } & {
    ordiniByKeyword: Maybe<
        { __typename?: 'Ordini' } & Pick<Ordini, 'conta'> & {
                lista: Array<
                    Maybe<
                        { __typename?: 'OrdineConArticoli' } & Pick<
                            OrdineConArticoli,
                            | 'id'
                            | 'destinatario'
                            | 'indirizzo'
                            | 'comune'
                            | 'prov'
                            | 'cap'
                            | 'statoOrdine'
                            | 'dataOrdine'
                            | 'dataConsegna'
                            | 'dataRitiro'
                            | 'orarioCarico'
                            | 'sommaPagamento'
                            | 'contanti'
                            | 'orarioAperturaMattina'
                            | 'orarioChiusuraMattina'
                            | 'orarioAperturaPomeriggio'
                            | 'orarioChiusuraPomeriggio'
                            | 'note'
                            | 'documento'
                            | 'tel'
                        > & {
                                cliente: Maybe<
                                    { __typename?: 'Cliente' } & Pick<
                                        Cliente,
                                        | 'id'
                                        | 'cod_cf'
                                        | 'cod_cf_in'
                                        | 'precod'
                                        | 'ragioneSociale'
                                        | 'indirizzo'
                                        | 'comune'
                                        | 'prov'
                                        | 'cap'
                                        | 'telefono'
                                        | 'email'
                                        | 'piva'
                                        | 'statoCliente'
                                    >
                                >;
                            }
                    >
                >;
            }
    >;
};

export type OrdiniQueryVariables = {
    statoOrdine?: Maybe<Array<Maybe<Scalars['Int']>>>;
    offset: Scalars['Int'];
    limit: Scalars['Int'];
};

export type OrdiniQuery = { __typename?: 'Query' } & {
    ordini: Maybe<
        { __typename?: 'Ordini' } & Pick<Ordini, 'conta'> & {
                lista: Array<
                    Maybe<
                        { __typename?: 'OrdineConArticoli' } & Pick<
                            OrdineConArticoli,
                            | 'id'
                            | 'destinatario'
                            | 'indirizzo'
                            | 'comune'
                            | 'prov'
                            | 'cap'
                            | 'statoOrdine'
                            | 'dataOrdine'
                            | 'dataConsegna'
                            | 'dataRitiro'
                            | 'orarioCarico'
                            | 'sommaPagamento'
                            | 'contanti'
                            | 'orarioAperturaMattina'
                            | 'orarioChiusuraMattina'
                            | 'orarioAperturaPomeriggio'
                            | 'orarioChiusuraPomeriggio'
                            | 'note'
                            | 'documento'
                            | 'tel'
                        > & {
                                cliente: Maybe<
                                    { __typename?: 'Cliente' } & Pick<
                                        Cliente,
                                        | 'id'
                                        | 'cod_cf'
                                        | 'cod_cf_in'
                                        | 'precod'
                                        | 'ragioneSociale'
                                        | 'indirizzo'
                                        | 'comune'
                                        | 'prov'
                                        | 'cap'
                                        | 'telefono'
                                        | 'email'
                                        | 'piva'
                                        | 'statoCliente'
                                    >
                                >;
                            }
                    >
                >;
            }
    >;
};

export type RuoliQueryVariables = {};

export type RuoliQuery = { __typename?: 'Query' } & {
    ruoli: Maybe<
        Array<Maybe<{ __typename?: 'Ruolo' } & Pick<Ruolo, 'id' | 'nome'>>>
    >;
};

export type UsersByKeywordQueryVariables = {
    criterioDiRicerca: Scalars['String'];
};

export type UsersByKeywordQuery = { __typename?: 'Query' } & {
    usersByKeyword: Maybe<
        Array<
            Maybe<
                { __typename?: 'Auth' } & Pick<
                    Auth,
                    | 'id'
                    | 'username'
                    | 'email'
                    | 'ultimoAccesso'
                    | 'statoUtente'
                    | 'tipologiaGiacenze'
                > & {
                        ruolo: Maybe<
                            { __typename?: 'Ruolo' } & Pick<
                                Ruolo,
                                'id' | 'nome'
                            >
                        >;
                        cliente: Maybe<
                            { __typename?: 'Cliente' } & Pick<
                                Cliente,
                                'id' | 'ragioneSociale' | 'piva' | 'cod_cf'
                            >
                        >;
                    }
            >
        >
    >;
};

export type UsersQueryVariables = {};

export type UsersQuery = { __typename?: 'Query' } & {
    users: Maybe<
        Array<
            Maybe<
                { __typename?: 'Auth' } & Pick<
                    Auth,
                    | 'id'
                    | 'username'
                    | 'email'
                    | 'ultimoAccesso'
                    | 'statoUtente'
                    | 'tipologiaGiacenze'
                > & {
                        ruolo: Maybe<
                            { __typename?: 'Ruolo' } & Pick<
                                Ruolo,
                                'id' | 'nome'
                            >
                        >;
                        cliente: Maybe<
                            { __typename?: 'Cliente' } & Pick<
                                Cliente,
                                'id' | 'ragioneSociale' | 'piva' | 'cod_cf'
                            >
                        >;
                    }
            >
        >
    >;
};

export const AggiungiClienteDocument = gql`
    mutation aggiungiCliente(
        $precod: String!
        $cod_cf: String!
        $cod_cf_in: String!
        $ragioneSociale: String!
        $piva: String!
        $indirizzo: String!
        $comune: String!
        $prov: String!
        $cap: String!
        $email: String
        $telefono: String
        $orarioAperturaMattina: String
        $orarioChiusuraMattina: String
        $orarioAperturaPomeriggio: String
        $orarioChiusuraPomeriggio: String
    ) {
        aggiungiCliente(
            precod: $precod
            cod_cf: $cod_cf
            cod_cf_in: $cod_cf_in
            ragioneSociale: $ragioneSociale
            piva: $piva
            indirizzo: $indirizzo
            comune: $comune
            prov: $prov
            cap: $cap
            email: $email
            telefono: $telefono
            orarioAperturaMattina: $orarioAperturaMattina
            orarioChiusuraMattina: $orarioChiusuraMattina
            orarioAperturaPomeriggio: $orarioAperturaPomeriggio
            orarioChiusuraPomeriggio: $orarioChiusuraPomeriggio
        ) {
            cod_cf
            cod_cf_in
            precod
            ragioneSociale
            indirizzo
            comune
            prov
            cap
            telefono
            email
            piva
            statoCliente
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class AggiungiClienteGQL extends Apollo.Mutation<
    AggiungiClienteMutation,
    AggiungiClienteMutationVariables
> {
    document = AggiungiClienteDocument;
}
export const AssegnaDocumentoDocument = gql`
    mutation assegnaDocumento($ordine: Int!, $documento: String) {
        assegnaDocumento(ordine: $ordine, documento: $documento) {
            id
            documento
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class AssegnaDocumentoGQL extends Apollo.Mutation<
    AssegnaDocumentoMutation,
    AssegnaDocumentoMutationVariables
> {
    document = AssegnaDocumentoDocument;
}
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
        login(_email: $email, password: $password) {
            username
            email
            token
            avatar
            ruolo {
                id
                nome
            }
            cliente {
                id
                ragioneSociale
                piva
            }
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class LoginGQL extends Apollo.Mutation<
    LoginMutation,
    LoginMutationVariables
> {
    document = LoginDocument;
}
export const ModificaPasswordUtenteDocument = gql`
    mutation modificaPasswordUtente($email: String!, $password: String!) {
        modificaPasswordUtente(email: $email, password: $password) {
            username
            email
            ultimoAccesso
            ruolo {
                id
                nome
            }
            cliente {
                id
                ragioneSociale
                piva
            }
            statoUtente
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class ModificaPasswordUtenteGQL extends Apollo.Mutation<
    ModificaPasswordUtenteMutation,
    ModificaPasswordUtenteMutationVariables
> {
    document = ModificaPasswordUtenteDocument;
}
export const ModificaStatoClienteDocument = gql`
    mutation modificaStatoCliente($piva: String!, $statoCliente: String!) {
        modificaStatoCliente(piva: $piva, statoCliente: $statoCliente) {
            clienti {
                cod_cf
                cod_cf_in
                precod
                ragioneSociale
                indirizzo
                comune
                prov
                cap
                telefono
                email
                piva
                statoCliente
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class ModificaStatoClienteGQL extends Apollo.Mutation<
    ModificaStatoClienteMutation,
    ModificaStatoClienteMutationVariables
> {
    document = ModificaStatoClienteDocument;
}
export const ModificaStatoOrdineDocument = gql`
    mutation modificaStatoOrdine($ordine: Int!, $statoOrdine: Int!) {
        modificaStatoOrdine(ordine: $ordine, statoOrdine: $statoOrdine) {
            lista {
                id
                cliente {
                    id
                    cod_cf
                    cod_cf_in
                    precod
                    ragioneSociale
                    indirizzo
                    comune
                    prov
                    cap
                    telefono
                    email
                    piva
                    statoCliente
                }
                statoOrdine
                dataOrdine
                dataConsegna
                orarioAperturaMattina
                orarioChiusuraMattina
                orarioAperturaPomeriggio
                orarioChiusuraPomeriggio
                note
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class ModificaStatoOrdineGQL extends Apollo.Mutation<
    ModificaStatoOrdineMutation,
    ModificaStatoOrdineMutationVariables
> {
    document = ModificaStatoOrdineDocument;
}
export const ModificaStatoUtenteDocument = gql`
    mutation modificaStatoUtente($email: String!, $statoUtente: String!) {
        modificaStatoUtente(email: $email, statoUtente: $statoUtente) {
            username
            email
            ultimoAccesso
            ruolo {
                id
                nome
            }
            cliente {
                id
                ragioneSociale
                piva
            }
            statoUtente
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class ModificaStatoUtenteGQL extends Apollo.Mutation<
    ModificaStatoUtenteMutation,
    ModificaStatoUtenteMutationVariables
> {
    document = ModificaStatoUtenteDocument;
}
export const ModificaUtenteDocument = gql`
    mutation modificaUtente(
        $email: String!
        $cod_cf: String!
        $ruolo: Int!
        $piva: String
        $tipologiaGiacenze: Int!
    ) {
        modificaUtente(
            email: $email
            cod_cf: $cod_cf
            ruolo: $ruolo
            piva: $piva
            tipologiaGiacenze: $tipologiaGiacenze
        ) {
            id
            username
            email
            ultimoAccesso
            ruolo {
                id
                nome
            }
            cliente {
                id
                ragioneSociale
                piva
                cod_cf
            }
            statoUtente
            tipologiaGiacenze
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class ModificaUtenteGQL extends Apollo.Mutation<
    ModificaUtenteMutation,
    ModificaUtenteMutationVariables
> {
    document = ModificaUtenteDocument;
}
export const RegistraOrdineDocument = gql`
    mutation registraOrdine(
        $destinatario: String!
        $indirizzo: String!
        $comune: String!
        $prov: String!
        $cap: String!
        $dataConsegna: Date
        $dataRitiro: Date
        $orarioCarico: String
        $orarioAperturaMattina: String
        $orarioChiusuraMattina: String
        $orarioAperturaPomeriggio: String
        $orarioChiusuraPomeriggio: String
        $note: String
        $articoli: [ArticoloInput]!
        $sommaPagamento: Float
        $contanti: Boolean
        $tel: String
    ) {
        registraOrdine(
            destinatario: $destinatario
            indirizzo: $indirizzo
            comune: $comune
            prov: $prov
            cap: $cap
            dataConsegna: $dataConsegna
            dataRitiro: $dataRitiro
            orarioCarico: $orarioCarico
            orarioAperturaMattina: $orarioAperturaMattina
            orarioChiusuraMattina: $orarioChiusuraMattina
            orarioAperturaPomeriggio: $orarioAperturaPomeriggio
            orarioChiusuraPomeriggio: $orarioChiusuraPomeriggio
            note: $note
            articoli: $articoli
            sommaPagamento: $sommaPagamento
            contanti: $contanti
            tel: $tel
        ) {
            lista {
                id
                ordine {
                    id
                    destinatario
                    cliente {
                        id
                        cod_cf
                        cod_cf_in
                        precod
                        ragioneSociale
                        indirizzo
                        comune
                        prov
                        cap
                        telefono
                        email
                        piva
                        statoCliente
                        orarioAperturaMattina
                        orarioChiusuraMattina
                        orarioAperturaPomeriggio
                        orarioChiusuraPomeriggio
                    }
                    statoOrdine
                    dataOrdine
                    dataConsegna
                    dataRitiro
                    orarioAperturaMattina
                    orarioChiusuraMattina
                    orarioAperturaPomeriggio
                    orarioChiusuraPomeriggio
                    note
                    documento
                    tel
                }
                COD_ART
                DES_ART
                COD_LOT
                COD_DEP
                DATA_SCAD
                quantita
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class RegistraOrdineGQL extends Apollo.Mutation<
    RegistraOrdineMutation,
    RegistraOrdineMutationVariables
> {
    document = RegistraOrdineDocument;
}
export const RegistraUtenteDocument = gql`
    mutation registraUtente(
        $username: String!
        $email: String!
        $password: String!
        $ruolo: String
        $piva: String
    ) {
        registraUtente(
            username: $username
            email: $email
            password: $password
            ruolo: $ruolo
            piva: $piva
        ) {
            id
            username
            email
            ruolo {
                id
                nome
            }
            cliente {
                id
                ragioneSociale
                piva
            }
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class RegistraUtenteGQL extends Apollo.Mutation<
    RegistraUtenteMutation,
    RegistraUtenteMutationVariables
> {
    document = RegistraUtenteDocument;
}
export const ClientiByKeywordDocument = gql`
    query clientiByKeyword(
        $criterioDiRicerca: String!
        $orderBy: String
        $filterBy: [String]
        $skip: Int
        $limit: Int
    ) {
        clientiByKeyword(
            criterioDiRicerca: $criterioDiRicerca
            orderBy: $orderBy
            filterBy: $filterBy
            skip: $skip
            limit: $limit
        ) {
            clienti {
                id
                cod_cf
                cod_cf_in
                precod
                ragioneSociale
                indirizzo
                comune
                prov
                cap
                telefono
                email
                piva
                statoCliente
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class ClientiByKeywordGQL extends Apollo.Query<
    ClientiByKeywordQuery,
    ClientiByKeywordQueryVariables
> {
    document = ClientiByKeywordDocument;
}
export const ClientiDocument = gql`
    query clienti(
        $orderBy: String
        $filterBy: [String]
        $skip: Int
        $limit: Int
    ) {
        clienti(
            orderBy: $orderBy
            filterBy: $filterBy
            skip: $skip
            limit: $limit
        ) {
            clienti {
                cod_cf
                cod_cf_in
                precod
                ragioneSociale
                indirizzo
                comune
                prov
                cap
                telefono
                email
                piva
                statoCliente
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class ClientiGQL extends Apollo.Query<
    ClientiQuery,
    ClientiQueryVariables
> {
    document = ClientiDocument;
}
export const DestinazioneDocument = gql`
    query destinazione($DOC_ID: String!) {
        destinazione(DOC_ID: $DOC_ID) {
            DES_DEST_MERCE
            INDI_DEST_MERCE
            CAP_DEST_MERCE
            COMUNE_DEST_MERCE
            PROVINCIA_DEST_MERCE
            STATO_DEST_MERCE
            TEL_DEST_MERCE
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class DestinazioneGQL extends Apollo.Query<
    DestinazioneQuery,
    DestinazioneQueryVariables
> {
    document = DestinazioneDocument;
}
export const DettagliMovimentoInIngressoDocument = gql`
    query dettagliMovimentoInIngresso($DOC_ID: String!) {
        dettagliMovimentoInIngresso(DOC_ID: $DOC_ID) {
            COD_ART
            DES_RIGA
            QUANT_RIGA
            PESO_NETTO
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class DettagliMovimentoInIngressoGQL extends Apollo.Query<
    DettagliMovimentoInIngressoQuery,
    DettagliMovimentoInIngressoQueryVariables
> {
    document = DettagliMovimentoInIngressoDocument;
}
export const DettagliMovimentoInUscitaDocument = gql`
    query dettagliMovimentoInUscita($DOC_ID: String!) {
        dettagliMovimentoInUscita(DOC_ID: $DOC_ID) {
            COD_ART
            DES_RIGA
            QUANT_RIGA
            PESO_NETTO
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class DettagliMovimentoInUscitaGQL extends Apollo.Query<
    DettagliMovimentoInUscitaQuery,
    DettagliMovimentoInUscitaQueryVariables
> {
    document = DettagliMovimentoInUscitaDocument;
}
export const FetchArticoliByOrdineDocument = gql`
    query fetchArticoliByOrdine($ordine: Int!) {
        fetchArticoliByOrdine(ordine: $ordine) {
            lista {
                id
                COD_ART
                DES_ART
                quantita
                DATA_SCAD
                COD_LOT
                COD_DEP
                ordine {
                    id
                    documento
                    cliente {
                        id
                        cod_cf
                        cod_cf_in
                        precod
                        ragioneSociale
                        indirizzo
                        comune
                        prov
                        cap
                        telefono
                        email
                        piva
                        statoCliente
                    }
                }
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class FetchArticoliByOrdineGQL extends Apollo.Query<
    FetchArticoliByOrdineQuery,
    FetchArticoliByOrdineQueryVariables
> {
    document = FetchArticoliByOrdineDocument;
}
export const FetchBollaDocument = gql`
    query fetchBolla($DOC_ID: String!) {
        fetchBolla(DOC_ID: $DOC_ID)
    }
`;

@Injectable({
    providedIn: 'root',
})
export class FetchBollaGQL extends Apollo.Query<
    FetchBollaQuery,
    FetchBollaQueryVariables
> {
    document = FetchBollaDocument;
}
export const GeneraPasswordCasualeDocument = gql`
    query generaPasswordCasuale {
        generaPasswordCasuale {
            password
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class GeneraPasswordCasualeGQL extends Apollo.Query<
    GeneraPasswordCasualeQuery,
    GeneraPasswordCasualeQueryVariables
> {
    document = GeneraPasswordCasualeDocument;
}
export const GiacenzeByArticoloByKeywordDocument = gql`
    query giacenzeByArticoloByKeyword(
        $PreCod: String!
        $Totali: Int!
        $Obsoleti: Int!
        $Categoria: String!
        $offset: Int!
        $limit: Int!
        $criterioDiRicerca: String!
    ) {
        giacenzeByArticoloByKeyword(
            PreCod: $PreCod
            Totali: $Totali
            Obsoleti: $Obsoleti
            Categoria: $Categoria
            offset: $offset
            limit: $limit
            criterioDiRicerca: $criterioDiRicerca
        ) {
            articoli {
                COD_ART
                DES_ART
                GIACENZA_ATTUALE
                RESIDUO
                IMPEGNO
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class GiacenzeByArticoloByKeywordGQL extends Apollo.Query<
    GiacenzeByArticoloByKeywordQuery,
    GiacenzeByArticoloByKeywordQueryVariables
> {
    document = GiacenzeByArticoloByKeywordDocument;
}
export const GiacenzeByArticoloDocument = gql`
    query giacenzeByArticolo(
        $PreCod: String!
        $Totali: Int!
        $Obsoleti: Int!
        $Categoria: String!
        $offset: Int!
        $limit: Int!
    ) {
        giacenzeByArticolo(
            PreCod: $PreCod
            Totali: $Totali
            Obsoleti: $Obsoleti
            Categoria: $Categoria
            offset: $offset
            limit: $limit
        ) {
            articoli {
                COD_ART
                DES_ART
                GIACENZA_ATTUALE
                RESIDUO
                IMPEGNO
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class GiacenzeByArticoloGQL extends Apollo.Query<
    GiacenzeByArticoloQuery,
    GiacenzeByArticoloQueryVariables
> {
    document = GiacenzeByArticoloDocument;
}
export const GiacenzeByKeywordDocument = gql`
    query giacenzeByKeyword(
        $PreCod: String!
        $Totali: Int!
        $Obsoleti: Int!
        $Categoria: String!
        $offset: Int!
        $limit: Int!
        $criterioDiRicerca: String!
    ) {
        giacenzeByKeyword(
            PreCod: $PreCod
            Totali: $Totali
            Obsoleti: $Obsoleti
            Categoria: $Categoria
            offset: $offset
            limit: $limit
            criterioDiRicerca: $criterioDiRicerca
        ) {
            articoli {
                COD_ART
                DES_ART
                GIACENZA_ATTUALE
                RESIDUO
                IMPEGNO
                COD_DEP
                COD_LOT
                DATA_SCAD
                COD_CAT
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class GiacenzeByKeywordGQL extends Apollo.Query<
    GiacenzeByKeywordQuery,
    GiacenzeByKeywordQueryVariables
> {
    document = GiacenzeByKeywordDocument;
}
export const GiacenzeDocument = gql`
    query giacenze(
        $PreCod: String!
        $Totali: Int!
        $Obsoleti: Int!
        $Categoria: String!
        $offset: Int!
        $limit: Int!
    ) {
        giacenze(
            PreCod: $PreCod
            Totali: $Totali
            Obsoleti: $Obsoleti
            Categoria: $Categoria
            offset: $offset
            limit: $limit
        ) {
            articoli {
                COD_ART
                DES_ART
                GIACENZA_ATTUALE
                RESIDUO
                IMPEGNO
                COD_DEP
                COD_LOT
                DATA_SCAD
                COD_CAT
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class GiacenzeGQL extends Apollo.Query<
    GiacenzeQuery,
    GiacenzeQueryVariables
> {
    document = GiacenzeDocument;
}
export const MeDocument = gql`
    query me {
        me {
            username
            email
            token
            avatar
            ruolo {
                id
                nome
            }
            cliente {
                id
                cod_cf
                cod_cf_in
                precod
                ragioneSociale
                indirizzo
                comune
                prov
                cap
                telefono
                email
                piva
                statoCliente
                orarioAperturaMattina
                orarioChiusuraMattina
                orarioAperturaPomeriggio
                orarioChiusuraPomeriggio
            }
            tipologiaGiacenze
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class MeGQL extends Apollo.Query<MeQuery, MeQueryVariables> {
    document = MeDocument;
}
export const MovimentiInIngressoDocument = gql`
    query movimentiInIngresso(
        $offset: Int!
        $limit: Int!
        $COD_CF_IN: String
        $criterioDiRicerca: String
    ) {
        movimentiInIngresso(
            offset: $offset
            limit: $limit
            COD_CF_IN: $COD_CF_IN
            criterioDiRicerca: $criterioDiRicerca
        ) {
            movimenti {
                DOC_ID
                ANNO_DOC
                NUM_DOC
                DATA_DOC
                NUM_DDT_FOR
                DATA_DDT_FOR
                COD_CF
                cliente {
                    id
                    cod_cf
                    cod_cf_in
                    precod
                    ragioneSociale
                    indirizzo
                    comune
                    prov
                    cap
                    telefono
                    email
                    piva
                    statoCliente
                }
            }
            count
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class MovimentiInIngressoGQL extends Apollo.Query<
    MovimentiInIngressoQuery,
    MovimentiInIngressoQueryVariables
> {
    document = MovimentiInIngressoDocument;
}
export const MovimentiInUscitaDocument = gql`
    query movimentiInUscita(
        $offset: Int!
        $limit: Int!
        $COD_CF: String
        $criterioDiRicerca: String
    ) {
        movimentiInUscita(
            offset: $offset
            limit: $limit
            COD_CF: $COD_CF
            criterioDiRicerca: $criterioDiRicerca
        ) {
            movimenti {
                DOC_ID
                ANNO_DOC
                NUM_DOC
                DATA_DOC
                COD_CF
                cliente {
                    id
                    cod_cf
                    cod_cf_in
                    precod
                    ragioneSociale
                    indirizzo
                    comune
                    prov
                    cap
                    telefono
                    email
                    piva
                    statoCliente
                }
            }
            count
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class MovimentiInUscitaGQL extends Apollo.Query<
    MovimentiInUscitaQuery,
    MovimentiInUscitaQueryVariables
> {
    document = MovimentiInUscitaDocument;
}
export const OrdiniByKeywordDocument = gql`
    query ordiniByKeyword(
        $statoOrdine: [Int]
        $criterioDiRicerca: String!
        $offset: Int!
        $limit: Int!
    ) {
        ordiniByKeyword(
            statoOrdine: $statoOrdine
            criterioDiRicerca: $criterioDiRicerca
            offset: $offset
            limit: $limit
        ) {
            lista {
                id
                cliente {
                    id
                    cod_cf
                    cod_cf_in
                    precod
                    ragioneSociale
                    indirizzo
                    comune
                    prov
                    cap
                    telefono
                    email
                    piva
                    statoCliente
                }
                destinatario
                indirizzo
                comune
                prov
                cap
                statoOrdine
                dataOrdine
                dataConsegna
                dataRitiro
                orarioCarico
                sommaPagamento
                contanti
                orarioAperturaMattina
                orarioChiusuraMattina
                orarioAperturaPomeriggio
                orarioChiusuraPomeriggio
                note
                documento
                tel
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class OrdiniByKeywordGQL extends Apollo.Query<
    OrdiniByKeywordQuery,
    OrdiniByKeywordQueryVariables
> {
    document = OrdiniByKeywordDocument;
}
export const OrdiniDocument = gql`
    query ordini($statoOrdine: [Int], $offset: Int!, $limit: Int!) {
        ordini(statoOrdine: $statoOrdine, offset: $offset, limit: $limit) {
            lista {
                id
                cliente {
                    id
                    cod_cf
                    cod_cf_in
                    precod
                    ragioneSociale
                    indirizzo
                    comune
                    prov
                    cap
                    telefono
                    email
                    piva
                    statoCliente
                }
                destinatario
                indirizzo
                comune
                prov
                cap
                statoOrdine
                dataOrdine
                dataConsegna
                dataRitiro
                orarioCarico
                sommaPagamento
                contanti
                orarioAperturaMattina
                orarioChiusuraMattina
                orarioAperturaPomeriggio
                orarioChiusuraPomeriggio
                note
                documento
                tel
            }
            conta
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class OrdiniGQL extends Apollo.Query<OrdiniQuery, OrdiniQueryVariables> {
    document = OrdiniDocument;
}
export const RuoliDocument = gql`
    query ruoli {
        ruoli {
            id
            nome
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class RuoliGQL extends Apollo.Query<RuoliQuery, RuoliQueryVariables> {
    document = RuoliDocument;
}
export const UsersByKeywordDocument = gql`
    query usersByKeyword($criterioDiRicerca: String!) {
        usersByKeyword(criterioDiRicerca: $criterioDiRicerca) {
            id
            username
            email
            ultimoAccesso
            ruolo {
                id
                nome
            }
            cliente {
                id
                ragioneSociale
                piva
                cod_cf
            }
            statoUtente
            tipologiaGiacenze
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class UsersByKeywordGQL extends Apollo.Query<
    UsersByKeywordQuery,
    UsersByKeywordQueryVariables
> {
    document = UsersByKeywordDocument;
}
export const UsersDocument = gql`
    query users {
        users {
            id
            username
            email
            ultimoAccesso
            ruolo {
                id
                nome
            }
            cliente {
                id
                ragioneSociale
                piva
                cod_cf
            }
            statoUtente
            tipologiaGiacenze
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class UsersGQL extends Apollo.Query<UsersQuery, UsersQueryVariables> {
    document = UsersDocument;
}
export interface IntrospectionResultData {
    __schema: {
        types: {
            kind: string;
            name: string;
            possibleTypes: {
                name: string;
            }[];
        }[];
    };
}

const result: IntrospectionResultData = {
    __schema: {
        types: [],
    },
};

export default result;
